var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-item-wrapper',_vm._b({class:_vm.formItemClass,attrs:{"rules":_vm.rules}},'form-item-wrapper',_vm.bind,false),[_c('el-input',{attrs:{"value":_vm.fieldModel,"readonly":"","placeholder":_vm.placeholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }